import React, { useState, useEffect, useRef } from "react";
import { Form } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { getUserActivityLogs } from "../../services/commonService";
import { toast } from "react-toastify";
import moment from "moment";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import serach_icon from "../../assets/images/icon/search-icon.svg";
import { decryptDataFromArray } from "helpers/EncDec";
import { generateMaskedPII, getCompanyTimezoneDateTime } from "helpers/utils";
import { useTranslation } from "react-i18next";

function UserActivityLogs() {
  const { t } = useTranslation();

  const [logData, setLogData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);

  // filters
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const tableWrapperRef = useRef(null);

  const buildParams = (page, limit, overrides = {}) => ({
    page,
    limit,
    ...(search && { search }),
    ...(fromDate && { from_date: fromDate }),
    ...(toDate && { to_date: toDate }),
    ...overrides,
  });

  const fetchLogs = (page = 1, limit = 10, paramOverrides = {}) => {
    const params = buildParams(page, limit, paramOverrides);
    getUserActivityLogs(params)
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);

        if (responseData?.status) {
          setLogData(responseData?.data);
          setTotalCount(responseData?.total || responseData?.total_counts || 0);
        } else {
          toast.error(t(`User Activity.No data available`));
        }
      })
      .catch(() => {
        toast.error(t(`User Activity.No data available`));
      });
  };

  useEffect(() => {
    fetchLogs(1, sizePerPage);
  }, []);

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) document.body.classList.add(`theme-${theme}`);
  }, []);

  const handleSearch = e => {
    const value = e.target.value;
    setSearch(value);
    setCurrentPage(1);
    fetchLogs(1, sizePerPage, { search: value });
  };

  const handleApply = () => {
    setCurrentPage(1);
    fetchLogs(1, sizePerPage);
  };

  const handleReset = () => {
    setSearch("");
    setFromDate("");
    setToDate("");
    setCurrentPage(1);
    getUserActivityLogs({ page: 1, limit: sizePerPage })
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);
        if (responseData?.status) {
          setLogData(responseData?.data);
          setTotalCount(responseData?.total || responseData?.total_counts || 0);
        }
      })
      .catch(() => {});
  };

  const handleTableChange = (type, { page, sizePerPage: newSize }) => {
    setCurrentPage(page);
    setSizePerPage(newSize);
    fetchLogs(page, newSize);
  };

  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -100 : 100,
        behavior: "smooth",
      });
    }
  };

  const columns = [
    {
      dataField: "admin_name",
      text: t(`User Activity.Admin Name`),
      classes: "text-center",
      headerClasses: "text-center",
      formatter: (cell, row) => <>{row?.user?.name || "-"}</>,
    },
    {
      dataField: "admin_email",
      text: t(`User Activity.Admin Email`),
      classes: "text-center",
      headerClasses: "text-center",
      formatter: (cell, row) => <>{generateMaskedPII(row?.user?.email)}</>,
    },
    {
      dataField: "user.role.name",
      text: t(`User Activity.Role`),
      classes: "text-center",
      headerClasses: "text-center",
      formatter: (cell, row) => <>{row?.user?.role?.name || "-"}</>,
    },
    {
      dataField: "action",
      text: t(`User Activity.Action`),
      classes: "text-center",
      headerClasses: "text-center",
      formatter: cell => <>{cell || "-"}</>,
    },
    {
      dataField: "old_status",
      text: t(`User Activity.Old Status`),
      classes: "text-center",
      headerClasses: "text-center",
      formatter: cell => <>{cell || "-"}</>,
    },
    {
      dataField: "new_status",
      text: t(`User Activity.New Status`),
      classes: "text-center",
      headerClasses: "text-center",
      formatter: cell => <>{cell || "-"}</>,
    },
    {
      dataField: "applied_job.name",
      text: t(`User Activity.Candidate Name`),
      classes: "text-center",
      headerClasses: "text-center",
      formatter: (cell, row) => <>{row?.applied_job?.name || "-"}</>,
    },
    {
      dataField: "createdAt",
      text: t(`User Activity.Created At`),
      classes: "text-center",
      headerClasses: "text-center",
      formatter: cell =>
        cell
          ? moment(getCompanyTimezoneDateTime(cell)).format(
              "DD MMM YYYY hh:mm:ss a"
            )
          : "-",
    },
  ];

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`User Activity.Showing rows`, { from, to, size })}
    </span>
  );

  const paginationOptions = {
    paginationSize: 1,
    pageStartIndex: 1,
    page: currentPage,
    sizePerPage,
    totalSize: totalCount,
    alwaysShowAllBtns: true,
    withFirstAndLast: true,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  const rowClasses = (row, rowIndex) =>
    rowIndex % 2 === 0 ? "even-row" : "odd-row";

  return (
    <>
      <div className="outerTab-box-wrapper below-vacancy amsterresign applicationcard-table pt-4">
        <div className="franchise-list-page">
          <div className="tab-content" id="pills-tabContent">
            <div className="tab-pane fade show active" id="pills-home" role="tabpanel">
              <div className="tabel-application table-responsive pb-3">
                <div className="tabel-franchise table-responsive pb-3">

                  {/* ── Filters ── */}
                  <div className="table-data-search flex-wrap gap-2 mb-3">
                    <div className="total-record">
                      <h5>
                        {t(`User Activity.Total Records`)}:{" "}
                        <span>{totalCount || 0}</span>
                      </h5>
                    </div>

                    <div className="total-serachbar cookieslist flex-wrap gap-2">
                      {/* Search by name / email */}
                      <div className="serach-bar-top">
                        <form className="form-inline">
                          <input
                            className="form-control mr-sm-2"
                            type="search"
                            placeholder={t(`User Activity.Search By`)}
                            aria-label="Search"
                            value={search}
                            onChange={handleSearch}
                          />
                          <span>
                            <img src={serach_icon} alt="search" />
                          </span>
                        </form>
                      </div>

                      {/* Date range */}
                      <div className="serach-bar-top">
                        <Form.Control
                          type="date"
                          title={t(`User Activity.From Date`)}
                          value={fromDate}
                          onChange={e => setFromDate(e.target.value)}
                        />
                      </div>
                      <div className="serach-bar-top">
                        <Form.Control
                          type="date"
                          title={t(`User Activity.To Date`)}
                          value={toDate}
                          onChange={e => setToDate(e.target.value)}
                        />
                      </div>

                      {/* Apply / Reset */}
                      <div className="serach-bar-top d-flex gap-2">
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={handleApply}
                        >
                          {t(`User Activity.Apply`)}
                        </button>
                        <button
                          className="btn btn-secondary btn-sm"
                          onClick={handleReset}
                        >
                          {t(`User Activity.Reset`)}
                        </button>
                      </div>

                      {/* Scroll arrows */}
                      <div className="tale-text right-panel alapp arrow-btns">
                        <button
                          className="button left"
                          onClick={() => handleScroll("left")}
                          data-tooltip="Scroll Left"
                        >
                          <img src={right_arrow} alt="right-arrow" />
                        </button>
                        <button
                          className="button right"
                          onClick={() => handleScroll("right")}
                          data-tooltip="Scroll Right"
                        >
                          <img src={right_arrow} alt="right-arrow" />
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* ── Table ── */}
                  <div className="tabel-application table-responsive white-space-row pb-3">
                    <div className="timeto-hire-card userlist">
                      <div className="table-custome-class range-custome">
                        <div className="scroll-container">
                          <div className="table-pending-list">
                            <div className="table-wrapper" ref={tableWrapperRef}>
                              <BootstrapTable
                                keyField="id"
                                data={logData}
                                columns={columns}
                                remote={{ pagination: true }}
                                pagination={paginationFactory(paginationOptions)}
                                onTableChange={handleTableChange}
                                rowClasses={rowClasses}
                                hover
                                responsive
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserActivityLogs;
